import { createSelector } from 'reselect'

const selectMailer = (state) => state.mailer

const selectMailerFetching = createSelector(
  selectMailer,
  (mailer) => mailer.isFetching
)

const selectMailerSuccess = createSelector(
  selectMailer,
  (mailer) => mailer.success
)

const selectMailerError = createSelector(selectMailer, (mailer) => mailer.error)

export { selectMailerFetching, selectMailerSuccess, selectMailerError }
